import {
    parseAsInteger, useQueryState,
} from 'nuqs';

import {
    DEFAULT_CURRENT_PAGE,
    DEFAULT_ORDER_COLUMN, DEFAULT_ORDER_DIRECTION,
    DEFAULT_PAGE_SIZE,
    DEFAULT_SEARCH,
} from '@/constants';

type UseCustomParamsOptions = {
    defaultPageSize?: number;
};

export const useCustomParams = (options?: UseCustomParamsOptions) => {
    const { defaultPageSize = DEFAULT_PAGE_SIZE } = options ?? {};
    const [orderColumn, setOrderColumn] = useQueryState('order_column', { defaultValue: DEFAULT_ORDER_COLUMN });
    const [orderDirection, setOrderDirection] = useQueryState('order_direction', { defaultValue: DEFAULT_ORDER_DIRECTION });
    const [currentPage, setCurrentPage] = useQueryState('current_page', parseAsInteger.withDefault(DEFAULT_CURRENT_PAGE));
    const [pageSize, setPageSize] = useQueryState('per_page', parseAsInteger.withDefault(defaultPageSize));
    const [search, setSearch] = useQueryState('search', { defaultValue: DEFAULT_SEARCH });
    const [type, setType] = useQueryState('type');

    return {
        orderColumn,
        setOrderColumn,
        orderDirection,
        setOrderDirection,
        currentPage,
        setCurrentPage,
        pageSize,
        setPageSize,
        search,
        setSearch,
        type,
        setType,
    };
};
